import React from 'react';
import { withStyles, Typography, Icon, Button } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import ContentHeader from '../components/ContentHeader';

const styles = theme => ({
    root: {
        textAlign: 'center',
        border: '0',
        maxWidth: '800px',
        margin: '40px auto',
        position: 'relative',
        background: '#fff',
        boxShadow: '0px 2px 5px 0px rgba(0,0,0,0.21)',
        [theme.breakpoints.down('sm')]: {
            maxWidth: '100%',
            margin: '20px 15px'
        }
    },
    heading: {
        marginBottom: '10px'
    },
    subheading: {
        marginTop: '20px'
    },
    paragraph: {
        fontSize: '16px',
        marginBottom: '10px',
        fontWeight: '100'
    },
    inner: {
        padding: '20px 10px'
    },
    button: {
        marginTop: 20
    }
});

const TicketSent = ({ classes }) => {
    const history = useHistory();
    return (
        <div className={classes.root}>
            <ContentHeader text="Ticket sent" id="ticket-sent-heading" />
            <div className={classes.inner}>
                <Typography className={classes.paragraph} variant="body2">
                    Your ticket was sent to the passenger.
                </Typography>
                <Typography className={classes.paragraph} variant="body2">
                    They can now access the ticket on their mobile device by
                    opening the private ticket link in the email.
                </Typography>
                <Typography className={classes.paragraph} variant="body2">
                    The email should arrive instantly. If the passenger doesn
                    &apos;t see it, ask them to check their spam folder.
                </Typography>
                <Typography className={classes.paragraph} variant="body2">
                    <strong>NOTE:</strong> Often a simple typo is the reason for
                    a ticket not arriving. Try send again but take extra when
                    entering the email address.
                </Typography>

                <Button
                    className={classes.button}
                    variant="outlined"
                    color="primary"
                    onClick={() => {
                        history.goBack();
                    }}
                >
                    <Icon className={classes.icon}>arrow_back</Icon>
                    Back to ticket
                </Button>
            </div>
        </div>
    );
};

export default withStyles(styles)(TicketSent);
